import React from "react";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import DashboardLoader from "../../components/DashboardLoader";
import useQuery from "../../hooks/useQuery";
import cogoToast from "cogo-toast";
import { useAuthContext } from "../../context/providers/AuthContext";
const Auth = (props) => {
	const query = useQuery();
	const token = query.get("token") || localStorage.getItem("token");
	const authErrorRedirect = process.env.REACT_APP_ACADEMY_SERVER;
	const { loadUser, isAuthenticated, error, clearNotification } = useAuthContext();
	const showError = (message) => cogoToast.error(message);
	React.useEffect(() => {
		if (token) {
			localStorage.setItem("token", token);
			loadUser();
			if (isAuthenticated) {
				props.history.push("/");
			} else {
				if (error !== null) {
					showError(error);
					clearNotification();
					window.location = authErrorRedirect;
				}
			}
		} else {
			window.location = authErrorRedirect;
		}
		//eslint-disable-next-line
	}, [isAuthenticated, error, props.history]);

	return <DashboardLoader />;
};

export default Auth;
